// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { EmailLink } from 'src/modules/unread-emails/jsx/component.jsx';
import { sq_personalise } from 'src/lib/personalisation.js';
import { gu_auth } from 'src/lib/authentication.js';


// Stateful components

export class NavigationMenu extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};

    }

    componentDidMount() {
        var this_component = this;
        
    }


    //
    // Functions
    //

    isItemActive(current_page, menu_item) {
        var item_slug = menu_item['slug'];
        var is_active = false;

        // Check if page is active
        if(item_slug === current_page) {
            is_active = true;
        }

        // Check for home
        if(current_page === 'home' && item_slug === '') {
            is_active = true;
        }

        // Check the children
        menu_item['children'].forEach(function(child, child_index) {
            if(child['slug'] === current_page) {
                is_active = true;
            }
        });

        return is_active;
    }

    //
    // Render
    //

    // Render page navigation
    renderMainNavigation() {
        var this_component = this;
        var portal_context = this_component['context'];

        var user_personalisation = portal_context['user_personalisation'];
        var current_page = portal_context['current_page'];
        var all_pages = portal_context['all_pages'];

        // Get personalised results
        var filtered_menu_items = sq_personalise.fn.filterItems(all_pages, user_personalisation['attributes']);
        
        // Build the menu items
        var menu_items = filtered_menu_items.map(function(item, item_index) {
            var item_key = item['id'];
            var item_name = item['name'];
            var item_class = 'nav-primary__item';
            var is_active = this_component.isItemActive(current_page, item);
            
            // based on link_type, only use items with a value of 1.
            var show_in_menu = item['link_type'] === 1;

            // Handle home page
            if(item['slug'] === 'home') {
                item['slug'] = '';
            }

            // Handle active states
            if(is_active) {
                item_class += ' active';
            }

            var item_link = '#/' + item['slug'];
            var item_icon = {
                '__html': item['icon']
            };
            if(show_in_menu){
                return (
                    <li key={item_key} className={item_class}>
                        {is_active ? (
                        <a href={item_link} className="nav-primary__link" role="menuitem">
                            <div className="nav__icon" dangerouslySetInnerHTML={item_icon}></div>
                            <span className="nav__link-text">{item_name}</span>
                        </a>
                        ) : (
                        <a href={item_link} className="nav-primary__link" role="menuitem" onClick={portal_context['helpers']['closeMobileNav']}>
                            <div className="nav__icon" dangerouslySetInnerHTML={item_icon}></div>
                            <span className="nav__link-text">{item_name}</span>
                        </a>
                        )}
                    </li>
                );
            }
            
        });
        
        // Render
        return (
            <ul className="nav-primary__list" role="menubar">
                {menu_items}
            </ul>
        )
    }

    // Links from the header, viewable on mobile only
    renderSecondaryLinks() {
        var this_component = this;
        var portal_context = this_component['context'];

        var viewport = portal_context['viewport'];
        var secondary_links = portal_context['configuration']['portal_header']['links'];
        var feedback_link = this_component.renderFeedbackLink('mobile');
        
        if(viewport < 3) {
            // Build the menu items
            var menu_items = secondary_links.map(function(item, item_index) {
                var item_key = item['id'];
                var item_name = item['name'];
                var item_link = item['url'];
                var item_elem = item_name;

                if(item_name === 'Email') {
                    item_elem = <EmailLink />;
                }

                return (
                    <li key={item_key} className="nav-secondary__item">
                        <a href={item_link} className="nav-secondary__link">
                            <span className="nav__link-text">{item_elem}</span>
                        </a>
                    </li>
                );
            });
            
            // Render
            return (
                <ul className="nav-secondary__list" role="menubar">
                    {menu_items}
                    {feedback_link}           
                </ul>
            );
        }

        return null;
    }

    renderFeedbackLink(link_type) {
        var this_component = this;
        var portal_context = this_component['context'];
        var viewport = portal_context['viewport'];
        var feedback_link = portal_context['configuration']['portal_links']['feedback'];

        // Mobile menu - secondary link
        if(link_type === 'mobile') {
            return (
                <li className="nav-secondary__item">
                    <a href={feedback_link['url']} className="nav-secondary__link">
                        <span className="nav__link-text">{feedback_link['name']}</span>
                    </a>
                </li>
            );
        }
        
        // Left hand navigation - feedback button
        if(link_type === 'desktop' && viewport === 3) {
            var feedback_icon = {
                '__html': feedback_link['icon']
            };

            return (
                <a href={feedback_link['url']} className="nav__feedback">
                    <span dangerouslySetInnerHTML={feedback_icon}></span>
                    <span className="nav__feedback-text">Provide Feedback</span>
                </a>
            );
        }

        return null;
    }

    renderLogoutLink() {
        var this_component = this;
        var portal_context = this_component['context'];
        var logout_link = portal_context['configuration']['portal_links']['logout'];
        var logout_icon = {
            '__html': logout_link['icon']
        };
        
        return (
            <a href={logout_link['url']} className="nav__logout" target="_self" onClick={gu_auth.fn.logout}>
                <div className="nav__icon" dangerouslySetInnerHTML={logout_icon}></div>
                <span className="nav__link-text">{logout_link['name']}</span>
            </a>
        );
    }

    render() {
        var this_component = this;

        var main_navigation = this_component.renderMainNavigation();
        var secondary_links = this_component.renderSecondaryLinks();
        var feedback_link = this_component.renderFeedbackLink('desktop');
        var logout_link = this_component.renderLogoutLink();

        return (
            <div id="main__nav" className="navigation__wrapper" data-ga-label="Navigation">
                <nav className="navigation">
                    {main_navigation}
                    {secondary_links}
                    {logout_link}
                </nav>
                {feedback_link}
            </div>
        );
    }

};

NavigationMenu.contextType = PortalContext;
